<template>
  <footer>
    <span class="copyright">&copy; 2021 - <a target="_blank" href="https://instagram.com/thehighdynamic">@thehighdynamic</a></span>

    <router-link to="/legal" title="Terms, conditions and licens">legal</router-link>
    <router-link to="/contact" title="Contact information">contact</router-link>

    <a v-if="!inCartConfig" class="insta-cta" href="https://www.instagram.com/cityphography" target="_blank" @click="instaVisit">
      <div class="logo" /> follow our cool instagram &hearts; 
    </a>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "Footer",
  computed: {
    ...mapState([
      'inCartConfig'
    ]),
  },
  methods: {
    instaVisit(){
      this.appInsights.trackEvent({name: "InstaVisit"});
    }
  }
};
</script>

<style lang="scss">
footer {
  margin: 0 20px;
  border-top: 1px solid var(--color-footer-border);
  font-size: 14px;
  //line-height: 50px;
  line-height: 30px;
  overflow: hidden;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  padding: 10px 0;
  margin-bottom: 40px;

  .copyright {
    //float: left;
    display: block;

    a{
      margin-left: 10px;
    }
  }

  a {
    //float: right;
    margin-left: 20px;
  }

  .insta-cta{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: var(--color-header);
    margin: 0;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.15);
    line-height: 40px;
    font-family: Averia;
    font-size: 16px;
    z-index: 3000;
    vertical-align: middle;
    text-align: center;

    // &:after{
    //   content: 'x';      
    //   font-size: 20px;
    //   padding: 0 10px;
    //   font-family: 'Courier New', Courier, monospace;
    //   float: right;
    //   opacity: 0.6;
    // }

    .logo{
      display: inline-block;
      vertical-align: middle;
      margin-right: 20px;
      margin-top: -2px;
      width: 20px;
      height: 20px;
      background: url(../assets/images/instagram-logo-100.png);
      background-size: contain;
      opacity: 0.5;

      animation: scale20 10s ease 5s infinite;
    }
  }

  @media (min-width: $S) {
    line-height: 50px;
    text-align: unset;
    padding: 0;

    .copyright {
      float: left;
    }

    a {
      float: right;
    }
  }
}

@keyframes scale20 {  
  0% {
    transform: scale(1);
  }
  3% {
    transform: scale(1.2);
  }
  6% {
    transform: scale(1);
  }
}

.dark footer .insta-cta{
  .logo{
    background: url(../assets/images/instagram-logo-100-white.png);
    background-size: contain;
    opacity: 0.7;
  }

}
</style>
